import React from "react";

const AboutServiceCard = ({ label, text, icon, img }) => {
  return (
    <div data-aos="zoom-in-up" className="bg-white group rounded-3xl h-fit md:h-auto w-full p-5 flex flex-col gap-y-5 shadow-lg">
      <figure className="w-full h-[14rem] md:h-[20rem] lg:h-[14rem] rounded-2xl overflow-hidden relative">
        <img
          className="w-full h-full group-hover:scale-105 transition-all duration-500 object-cover object-center"
          src={img}
          alt="img"
        />
        <span data-aos="zoom-in-up" className="block bg-[#0bb6d9] p-4 rounded-md border-2 border-white text-white text-3xl absolute bottom-5 right-5">
          {icon}
        </span>
      </figure>
      <h1 data-aos="zoom-in-up" className="text-xl text-center capitalize text-secondaryTextColor group-hover:text-[#0BB6D9] transition-all duration-500 familjen-font">
        {label}
      </h1>
    </div>
  );
};

export default AboutServiceCard;
